module.exports = __webpack_public_path__ + "img/office_edit.e1a9d255.svg";